var render = function render(){var _vm=this,_c=_vm._self._c;return _c('EmptyState',{attrs:{"message":_vm.__('Carregue em um subtipo'),"height":"calc(100vh - 150px)"}})
}
var staticRenderFns = []

export { render, staticRenderFns }